<template>
  <div class="mb-1">
    <label class="block text-sm font-bold text-700 mb-0 text-uppercase tracking-wider">Origen del Pedido</label>
    <div class="flex flex-row flex-nowrap w-full gap-1 mt-1">
      <div 
        v-for="origen in origenes"
        :key="origen.value"
        class="flex-auto"
      >
        <div 
          class="zapi-origin-card w-full m-0 border-round-xl border-2 flex align-items-center justify-content-center" 
          :class="[
            modelValue === origen.value ? 'origin-active' : 'origin-inactive',
            canalesPermitidos && !canalesPermitidos.includes(origen.value) ? 'origin-disabled' : ''
          ]" 
          @click="canalesPermitidos && !canalesPermitidos.includes(origen.value) ? null : cambiarCanal(origen.value)"
          style="min-height: 35px; padding: 0.23rem 0.23rem;"
        >
          <span class="text-center" style="font-size: clamp(0.75rem, 1.1vw, 0.95rem); font-weight: 800; line-height: 1; word-break: keep-all; white-space: nowrap;">
            {{ origen.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CanalVentaService from '@/service/CanalVentaService';

export default {
  name: 'ZapiOriginSelector',
  props: {
    modelValue: { type: [String, Number], required: false },
    canalesPermitidos: { type: Array, default: null } // Array de IDs permitidos. Si es null, todos están permitidos
  },
  emits: ['update:modelValue', 'metodos-disponibles'],
  data() {
    return {
      origenes: [],
      canalesOriginales: [],
      canalVentaService: new CanalVentaService()
    }
  },
  mounted() {
    this.cargarCanales();
  },
  methods: {
    async cargarCanales() {
      try {
        const response = await this.canalVentaService.getCanalVentaSelect();
        const listaCanales = response.canales_venta || response.canalventa;
        if (listaCanales) {
          this.canalesOriginales = listaCanales;
          this.origenes = listaCanales.map(canal => {
            return {
              value: canal.id,
              label: canal.nombre
            };
          });
          
          // Validar la selección inmediatamente después de cargar los canales
          this.validarSeleccion();
        }
      } catch (error) {
        console.error("Error cargando canales de venta:", error);
      }
    },
    emitirMetodos(canal_id) {
      if (this.canalesOriginales.length === 0) return;
      const canalObj = this.canalesOriginales.find(c => c.id === canal_id);
      if (canalObj && canalObj.metodos_pago) {
        this.$emit('metodos-disponibles', canalObj.metodos_pago);
      }
    },
    validarSeleccion() {
      if (this.origenes.length > 0) {
        const existe = this.origenes.find(o => o.value === this.modelValue);
        // Si el valor actual no está en la lista de orígenes, forzamos la selección del primer elemento (índice 0)
        if (!existe) {
          const defaultVal = this.origenes[0].value;
          this.$emit('update:modelValue', defaultVal);
          this.emitirMetodos(defaultVal);
        } else {
          this.emitirMetodos(this.modelValue);
        }
      }
    },
    cambiarCanal(canal) {
      this.$emit('update:modelValue', canal);
      // Se eliminó emitirMetodos(canal) aquí para evitar lag por doble render,
      // ya que el 'watch' de modelValue lo ejecutará automáticamente.
    }
  },
  watch: {
    modelValue() {
      // Vigilar cuando cambia desde VentaPOS (ej. cuando se resetea la venta a 'mostrador')
      // para forzar la selección del primer origen válido
      this.validarSeleccion();
    }
  }
}
</script>

<style scoped>
.zapi-origin-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-color: #f0ebe2; /* Borde idéntico al ZapiProductCard */
  padding: 0.4rem 0;
  background-color: white;
  color: #4b5563;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out;
}
.zapi-origin-card:hover {
  background-color: #f9fafb;
}

/* =========================================
   ESTILOS GENÉRICOS (ACTIVO/INACTIVO)
   ========================================= */

.origin-active {
  background-color: #e32f3a !important;
  border-color: #e32f3a !important;
  color: white !important;
}
.origin-inactive {
  background-color: white !important;
  border-color: #f0ebe2 !important;
  color: #4b5563 !important;
}
.origin-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #f3f4f6 !important;
  pointer-events: none;
}
</style>
